import objectFitImages from "object-fit-images";
import objectFitVideos from "object-fit-videos";
import propTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/index";
import "./MediaContainer.css";

class MediaContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoReadyToPlay: false,
      imageReadyToShow: false,
      videoFinished: false,
      loopCanPlayThrough: false
    };
    this.videoLoop = React.createRef();
    this.videoTransition = React.createRef();
    this.backgroundImage = React.createRef();
    this.setVideoReadyToPlay = this.setVideoReadyToPlay.bind(this);
    this.setImageReadyToShow = this.setImageReadyToShow.bind(this);
  }
  componentDidMount() {
    // Image object-fit polyfill for Microsoft Edge 14
    objectFitImages();
  }
  componentWillReceiveProps() {
    console.log("Setting ready to play false");
    this.setState({
      videoReadyToPlay: false,
      videoFinished: false,
      imageReadyToShow: false,
      loopCanPlayThrough: false
    });
  }
  componentDidUpdate() {
    setTimeout(() => {
      this.props.backToParent && this.props.unsetNavigationWait();
    }, 2000);
  }
  setVideoFinished() {
    console.log("Setting video finished");
    this.setState({ videoFinished: true });
    setTimeout(() => {
      !this.props.backToParent && this.props.unsetNavigationWait();
    }, 100);
  }
  setVideoReadyToPlay() {
    console.log("Setting ready to play");
    this.setState({ videoReadyToPlay: true });
  }
  setImageReadyToShow() {
    this.setState({ imageReadyToShow: true });
  }
  render() {
    const {
      mediaData,
      allVideoTransitionsLoaded,
      allVideoLoopsLoaded,
      currentGroup,
      groupData
    } = this.props;
    const currentMediaData = mediaData[currentGroup];

    let showLoop =
      allVideoLoopsLoaded &&
      this.state.loopCanPlayThrough &&
      (this.state.videoFinished ||
        !this.state.videoReadyToPlay ||
        this.props.backToParent);

    let showVideo =
      allVideoTransitionsLoaded &&
      currentMediaData.videoTransition !== undefined &&
      this.state.videoReadyToPlay &&
      !this.state.videoFinished &&
      !this.props.backToParent;

    let showCurrentImage = 
      this.props.backToParent ||
      this.state.imageReadyToShow ||
      groupData.parentID === null ||
      groupData.parentID === "";

    const isIE = /MSIE|Trident/.test(navigator.userAgent);

    console.log(showVideo + " " + showCurrentImage);

    return (
      <section className="MediaContainer">
        <img
          key={
            showCurrentImage
              ? currentMediaData.image.src
              : mediaData[groupData.parentID].image.src
          }
          className={`MediaContainer__image`}
          src={
            showCurrentImage
              ? currentMediaData.image.src
              : mediaData[groupData.parentID].image.src
          }
          alt={
            showCurrentImage
              ? currentMediaData.image.alt
              : mediaData[groupData.parentID].image.alt
          }
          ref={this.backgroundImage}
          data-object-fit
        />        
        <video
          src={
            currentMediaData.videoTransition &&
            currentMediaData.videoTransition.src
          }
          ref={this.videoTransition}
          muted
          autoPlay
          playsInline
          onCanPlayThrough={() => {
            this.setVideoReadyToPlay();
            setTimeout(() => this.setImageReadyToShow(), 500);}
          }
          onEnded={() => this.setVideoFinished()}
          poster={
            groupData.parentID === null || groupData.parentID === ""
              ? currentMediaData.image.src
              : mediaData[groupData.parentID].image.src
          }
          className={`MediaContainer__video ${!showVideo ? "hide" : ""}`}
          style={{ top: `${isIE ? "-7vh" : "0px"}` }}
        />
      </section>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    backToParent: state.navigation.backToParent,
    unityAnimation: state.navigation.unityAnimation,
    loaded: !!(
      !props.unityAnimation ||
      (state.media.loadedVideos &&
        state.media.loadedVideos[props.unityAnimation])
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    unsetNavigationWait: () => {
      dispatch(actions.unsetNavigationWait());
    },
    setNavigationWait: () => {
      dispatch(actions.setNavigationWait());
    },
    setVideoLoaded: videoName => {
      dispatch(actions.setVideoLoaded(videoName));
    }
  };
}

MediaContainer.propTypes = {
  unsetNavigationWait: propTypes.func.isRequired,
  setNavigationWait: propTypes.func.isRequired,
  setVideoLoaded: propTypes.func.isRequired,
  unityAnimation: propTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaContainer);
